export const STATE_KEY = 'filters';
